export default function Forms() {
  return (
    <div className="container my-5">
      <div className="row">
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/Pre-marriage.pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">Pre-marriage Form</span>
          </a>
        </div>
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/marriage-noc.pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">Marriage NOC Form</span>
          </a>
        </div>
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/OATH OF FREE STATE.pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">OATH OF FREE STATE</span>
          </a>
        </div>
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/Baptism Registration.pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">Baptism Registration</span>
          </a>
        </div>
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/Baptism NOC.pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">Baptism NOC</span>
          </a>
        </div>
        <div className="col-12 text-start mb-4">
          <a href="/assets/forms/Baptism NOC(refletterform).pdf" target="_blank" rel="noopener noreferrer">
            <span className="text-center">Baptism NOC Reference letter form)</span>
          </a>
        </div>
      </div>
    </div>
  );
}
